import axios from "axios";
import { IReserveRequest, IValidationResponse } from "../types";
import { ISubjectQuotas } from "../reduxSlices/subjectsSlice";
import { axiosInstances } from "../components/AxiosManager/AxiosInstances";

export const getAxiosInstance = (idAlumnoPrograma: number) => {
  const id = idAlumnoPrograma % 10;
  const isLocalhost = window.location.hostname === "localhost";
  if (isLocalhost) {
    return axiosInstances.localhost;
  }
  return axiosInstances[`transacciones${id}` as keyof typeof axiosInstances];
};

export const getAxiosInstanceValidacion = (idAlumnoPrograma: number) => {
  const id = idAlumnoPrograma % 10;
  const isLocalhost = window.location.hostname === "localhost";
  if (isLocalhost) {
    return axiosInstances.localhost;
  }
  return axiosInstances[`validaciones${id}` as keyof typeof axiosInstances];
};

export const getAxiosInstanceOferta = (idAlumnoPrograma: number) => {
  const id = idAlumnoPrograma % 10;
  const isLocalhost = window.location.hostname === "localhost";
  if (isLocalhost) {
    return axiosInstances.localhost;
  }
  return axiosInstances[`oferta${id}` as keyof typeof axiosInstances];
};

export const getAxiosInstanceCupos = (idAlumnoPrograma: number) => {
  const id = idAlumnoPrograma % 10;
  const isLocalhost = window.location.hostname === "localhost";
  if (isLocalhost) {
    return axiosInstances.localhost;
  }
  return axiosInstances[`cupos${id}` as keyof typeof axiosInstances];
};
export const reserveSection = async (reserveData: IReserveRequest) => {
  const { data, status } = await getAxiosInstance(reserveData.idA).post(`/api/reservar`, reserveData);
  return { data, status };
};

export const changeSection = async (reserveData: IReserveRequest) => {
  const { data, status } = await getAxiosInstance(reserveData.idA).post(`/api/cambiarSeccion`, reserveData);
  return { data, status };
};

export const validarSuperposicionCambioSeccion = async (reserveData: IReserveRequest) => {
  const { data, status } = await getAxiosInstance(reserveData.idA).post(`/api/validarSuperposicion`, {
    ...reserveData,
    esCambioSeccion: true,
  });
  return { data, status };
};

export const validarReserva = async (reserveData: IReserveRequest): Promise<{ data: IValidationResponse; status: number }> => {
  const { data, status } = await getAxiosInstanceValidacion(reserveData.idA).post(`/api/validarInscripcion`, reserveData);
  return { data: data as IValidationResponse, status };
}; 

interface ICuposAlumnoResponse {
  error: boolean;
  errorMessage: string;
  idCurso: number;
  idCupo: number;
  cantidad: number;
  semaforo: number;
}

export interface ICupoSolicitud {
  idCupo: number;
  tipoMateria: "OBLIGATORIO" | "OPTATIVO";
}

const toCupos = (data: ICuposAlumnoResponse[], readyToUse: boolean = false): ISubjectQuotas => {
  return data.reduce((acc: any, e) => {
    return {
      ...acc,
      [e.idCupo]: { qty: e.cantidad, availability: e.semaforo, quotaId: e.idCupo, readyToUse },
    };
  }, {});
};

const fetchCuposAlumno = async (
  endpoint: string,
  idPersona: string,
  cupos: ICupoSolicitud[],
  readyToUse: boolean = false,
): Promise<{ data: ISubjectQuotas | null; status: number; response: ICuposAlumnoResponse[] | null }> => {
  try {
    const idAP = localStorage.getItem("idAP");
    const { data, status } = await getAxiosInstanceCupos(Number(idAP || idPersona)).post(
      `${endpoint}?r=${Math.random().toString()}`,
      { idPersona, cupos },
    );
    const response: ICuposAlumnoResponse[] = data;
    return { data: toCupos(data, readyToUse), status, response };
  } catch (error) {
    return { data: null, status: 401, response: null };
  }
};

/**
 * Obtiene los cupos de cursos fijados del alumno logueado
 */
export const getCuposAlumnoFijados = async (
  idPersona: string,
  cupos: ICupoSolicitud[],
  readyToUse: boolean = false
) => {
  return fetchCuposAlumno("/reservar/getCuposAlumnoFijados", idPersona, cupos, readyToUse);
};

/**
 * Obtiene los cupos del alumno logueado (oferta no fijada)
 */
export const getCuposAlumno = async (
  idPersona: string,
  cupos: ICupoSolicitud[],
  readyToUse: boolean = false
) => {
  return fetchCuposAlumno("/reservar/getCuposAlumno", idPersona, cupos, readyToUse);
};

/**
 * Obtiene los cupos de un curso específico
 * @param idCupoCurso - ID del cupo del curso
 * @returns - Objeto con los datos de los cupos
 */
export const getCuposCurso = async (idCupoCurso: number) => {
  const idAP = localStorage.getItem("idAP");
  const { data, status } = await getAxiosInstanceCupos(Number(idAP || 0)).post(`/reservar/getCuposCurso?r=${Math.random().toString()}`, {
    idCupoCurso,
  });
  const newData = toCupos([data], true);
  return { data: newData, status };
};
